import React from 'react';
import { withRouter } from 'react-router-dom';

const RouteHandler = ({ match }) => {
  window.logMessage('match', match);
  return <></>;
};

export default withRouter(RouteHandler);
